<img width="124" height="42" src="/images/AIAS_logo_124x46.png" alt="AIAS Logo" class="app-logo-normal">
<img width="20" height="25" src="/images/AIAS_logo_small_20x27.png" alt="AIAS Logo" class="app-logo-small">